const riskRewardMap = {
  '200': {
    label: '0% to 1%',
    category: 'Lower Risk Potential',
    class: 'green-thumb sm-thumb',
    name: 'Lower'
  },
  '210': {
    label: '0.5% to 2.5%',
    category: 'Lower Risk Potential',
    class: 'green-thumb sm-thumb',
    name: 'Lower'
  },
  '220': {
    label: '1.5% to 4.5%',
    category: 'Lower Risk Potential',
    class: 'green-thumb md-thumb',
    name: 'Lower'
  },
  '230': {
    label: '3.5% to 6.5%',
    category: 'Moderate Risk Potential',
    class: 'yellow-thumb md-thumb',
    name: 'Moderate'
  },
  '240': {
    label: '5.5% to 9.5%',
    category: 'Moderate Risk Potential',
    class: 'yellow-thumb md-thumb',
    name: 'Moderate'
  },
  '250': {
    label: '8.5% to 12.5%',
    category: 'Moderate Risk Potential',
    class: 'yellow-thumb md-thumb',
    name: 'Moderate'
  },
  '260': {
    label: '11.5% to 16.5%',
    category: 'Moderate Risk Potential',
    class: 'yellow-thumb lg-thumb',
    name: 'Moderate'
  },
  '270': {
    label: '15.5% to 20.5%',
    category: 'Higher Risk Potential',
    class: 'orange-thumb lg-thumb',
    name: 'Higher'
  },
  '280': {
    label: '19.5% to 24.5%',
    category: 'Higher Risk Potential',
    class: 'orange-thumb lg-thumb',
    name: 'Higher'
  },
  '290': {
    label: '>23.5%',
    category: 'Higher Risk Potential',
    class: 'orange-thumb sm-thumb',
    name: 'Higher'
  },
  default: {
    label: '5.5% to 9.5%',
    class: 'yellow-thumb lg-thumb',
    name: 'Moderate'
  }
};

export const getRRDisplay = riskLevel => {
  return riskRewardMap[riskLevel] || riskRewardMap.default;
};
